// ===== UTILITY =====
export const formatDate = (dateString) => {
  if (!dateString) return "--";
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  let date = new Date(dateString).toLocaleDateString(undefined, options);
  return date === "Invalid Date" ? "--" : date;
};

export const toMoney = (value) => {
  if (value === undefined || value === null || value === "") return "--";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toLocaleString("en-NG", { style: "currency", currency: "NGN" });
};

// Resolve a human-friendly label from a purchase/subscription/progress row.
export const rowLabel = (row) => {
  const label =
    row?.course?.title ||
    row?.course?.name ||
    row?.title ||
    row?.name ||
    row?.courseName ||
    row?.courseTitle ||
    row?.resourceName ||
    row?.planName ||
    row?.module?.title ||
    row?.plan ||
    row?.type ||
    (typeof row === "string" ? row : null);
  if (label) return String(label);
  if (row && typeof row === "object") {
    const keys = Object.keys(row).filter((k) => /name|title|course|plan|type/i.test(k));
    for (const k of keys) {
      const v = row[k];
      if (typeof v === "string" && v.length > 0) return v;
      if (v && typeof v === "object" && (v.title || v.name)) return v.title || v.name;
    }
  }
  return "N/A";
};

export const progressValue = (row) => {
  const raw =
    row?.progress ??
    row?.progressPercentage ??
    row?.percentage ??
    row?.completion ??
    row?.completedPercent ??
    row?.score ??
    (row?.modules
      ? Math.round(
          ((row.modules.completed || 0) / Math.max(1, row.modules.total || 0)) * 100
        )
      : null);
  const num = Number(raw);
  return Number.isNaN(num) ? 0 : Math.max(0, Math.min(100, num));
};

export const hoverActionStyles = `
  .hover-actions-wrapper { position: relative; display: inline-block; }
  .hover-actions-trigger {
    cursor: pointer; padding: 6px 12px; border-radius: 6px;
    background: #f1f5f9; border: 1px solid #e2e8f0;
    font-size: 13px; font-weight: 500; color: #475569;
    transition: all 0.2s; white-space: nowrap; display: inline-flex;
    align-items: center; gap: 8px;
  }
  .hover-actions-trigger:hover { background: #e2e8f0; border-color: #cbd5e1; }
  .hover-actions-trigger.active { background: #e2e8f0; border-color: #cbd5e1; }
  .hover-actions-popup {
    position: absolute; right: 0; top: 100%; margin-top: 6px; min-width: 230px;
    background: white; border-radius: 10px; border: 1px solid #e2e8f0;
    box-shadow: 0 10px 40px rgba(0,0,0,0.12); z-index: 100;
    overflow: hidden; padding: 6px;
  }
  .hover-action-item {
    display: flex; align-items: center; gap: 10px; width: 100%;
    padding: 9px 12px; border: none; background: transparent;
    border-radius: 6px; font-size: 13px; font-weight: 500; color: #334155;
    cursor: pointer; transition: all 0.15s; text-align: left; text-decoration: none;
  }
  .hover-action-item:hover { background: #f1f5f9; }
  .hover-action-item .action-icon { width: 18px; text-align: center; font-size: 13px; color: #64748b; }
  .hover-action-item.text-danger:hover { background: #fef2f2; color: #dc2626; }
  .hover-action-item.text-success:hover { background: #dcfce7; color: #16a34a; }
  .hover-action-item.text-danger:hover .action-icon,
  .hover-action-item.text-success:hover .action-icon { color: inherit; }
  .hover-action-divider { height: 1px; background: #e2e8f0; margin: 4px 6px; }
  .progress-pill { display: inline-block; padding: 2px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; }

  /* ── Mobile responsive: table → cards ─────────────────────────────── */
  @media (max-width: 768px) {
    .admin-table-responsive table,
    .admin-table-responsive thead,
    .admin-table-responsive tbody,
    .admin-table-responsive th,
    .admin-table-responsive td,
    .admin-table-responsive tr {
      display: block;
      width: 100%;
    }
    .admin-table-responsive thead {
      display: none;
    }
    .admin-table-responsive tbody tr {
      margin-bottom: 14px;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 6px 12px;
      background: #fff;
      box-shadow: 0 1px 3px rgba(0,0,0,0.04);
    }
    .admin-table-responsive tbody td {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      padding: 10px 4px;
      border-bottom: 1px solid #f1f5f9;
      text-align: right;
      font-size: 13px;
    }
    .admin-table-responsive tbody td:last-child {
      border-bottom: none;
    }
    .admin-table-responsive tbody td::before {
      content: attr(data-label);
      font-weight: 600;
      color: #475569;
      text-align: left;
      flex-shrink: 0;
      font-size: 12px;
    }
    .admin-table-responsive tbody td .hover-actions-wrapper {
      justify-content: flex-end;
    }
    .admin-table-responsive tbody td .hover-actions-wrapper > span {
      display: none;
    }
  }
`;
